import { ApolloError } from "@apollo/client";
import styled from "@emotion/styled";
import { Box } from "@mui/material";
import { ErrorDisplay } from "./ErrorDisplay";

interface OmnisearchErrorDisplayProps {
  error: Error;
  onClear?: () => void;
}

const StyledGridOverlay = styled("div")({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  minHeight: "100%",
  zIndex: 10,
  paddingTop: 24,
  width: "100%",
  "& .no-rows-primary": {
    fill: "#3D4751",
  },
  "& .no-rows-secondary": {
    fill: "#1D2126",
  },
});

export const OmnisearchErrorDisplay = ({
  error,
  onClear,
}: OmnisearchErrorDisplayProps) => {
  const apolloError = error instanceof ApolloError ? error : undefined;

  return (
    <StyledGridOverlay>
      <Box
        sx={{
          width: "100%",
          px: 2,
          maxHeight: "400px",
          overflowY: "scroll",
          height: "100%",
        }}
      >
        <ErrorDisplay
          error={error}
          apolloError={apolloError}
          compact={true}
          mainText="We've encountered an error, try another search"
          onAction={onClear}
          actionLabel="Reset Search"
        />
      </Box>
    </StyledGridOverlay>
  );
};
